import React from 'react'
import styled from 'styled-components';
import { Form, Input, Col, Icon, Button, Checkbox } from 'antd'
import CheckboxGroup from 'antd/lib/checkbox/Group';

import I18n from '@src/i18n';

const InputGroup = Input.Group;

class SearchComponent extends React.Component<any, any> {
  constructor(props: any) {
    super(props)
    this.state = {
      scheduleFilters: [
        { type: 'overdue', value: 5, label: I18n.l('schedule.filter.OVERDUE') },
        { type: 'pendent', value: 1, label: I18n.l('schedule.filter.PENDENT') }
      ],
      search: ''
    }

    this.handleChangeSearch = this.handleChangeSearch.bind(this)
  }

  handleChangeSearch (e: any) {
    this.setState({ search: e.target.value })
  }

  render() {
    const { scheduleFilters, search } = this.state
    const { activeTab, currentFilter, onChangeFilters, onSearch } = this.props

    return (
      <SearchContainer className="search-component">
        <Form layout="inline">
          <InputGroup size="large">
            <Col span={12}>
              <Input
                suffix={<Icon type="search" />}
                placeholder={I18n.l('form.placeholders.formflowSearch')}
                name="find"
                id="find"
                size="large"
                onChange={this.handleChangeSearch}
                value={search}
              />
            </Col>
            <Col span={2}>
              <Button size="large" onClick={() => onSearch(search)}>{I18n.l('common.search')}</Button>
            </Col>
            <Col span={10}>
              {activeTab === 'scheduled' && <CalendarFilters>
                <p className="check-label">{I18n.l('show')}</p>
                <CheckboxGroup onChange={onChangeFilters} defaultValue={currentFilter}>
                  {scheduleFilters && scheduleFilters.map((r: any) => <Checkbox value={r.value} className={r.type}>{r.label}</Checkbox>)}
                </CheckboxGroup>
              </CalendarFilters>}
            </Col>
          </InputGroup>
        </Form>
      </SearchContainer>
    )
  }
}

export default SearchComponent

const SearchContainer = styled.div`
  display: block;
  width: 100%;
  padding-bottom: 15px;

  Button{
    font-weight: bold;
    text-transform: uppercase;
    margin-left:6px;
    border-color: #1890ff;
    color: #1890ff;
  }
`;

export const CalendarFilters = styled.div`
  display: block;
  .check-label {
    font-style: normal;
    font-weight: bold;
    font-size: 11px;
    line-height: 14px;
    text-transform: uppercase;
    color: #8493AA;
    display: inline;
    padding-right: 15px;
  }
  .ant-checkbox-wrapper {
    border: 1px solid #000000;
    padding: 5px 10px;
    border-radius: 5px;
    background-color: lightgrey;
    font-size: 14px;
    &.pendent {
      background-color: #F4F4F4;
      border-color: #697478;
      color: #697478;
      .ant-checkbox-inner {
        background-color: #D1D1D1;
        border-color: #697478;
      }
      &.ant-checkbox-wrapper-checked {
        .ant-checkbox-inner {
          background-color: #697478;
        }
      }
    }
    &.overdue {
      background-color: #FFF1F1;
      border-color: #D93838;
      color: #D93838;
      .ant-checkbox-inner {
        background-color: #FFBABA;
        border-color: #D93838;
      }
      &.ant-checkbox-wrapper-checked {
        .ant-checkbox-inner {
          background-color: #D93838;
        }
      }
    }
  }
  .ant-checkbox-checked::after {
    border-color: transparent;
  }
`;